import { useState, useEffect } from 'react';
import { fetchOAuthClient, createOAuthClient, updateOAuthClient } from 'admin/actions/oauth-client';

const defaultValues = {
  id: '',
  name: '',
  client_secret: '',
  redirect_uri: '',
  allowed_grant_types: [],
  default_scopes: [],
  organization: null,
  default_private_money: null,
  creating_account_type: 'NONE',
  description: '',
  oauth_client_image: null,
  conceal_user_existence: 'always',
};

const useOAuthClient = (oauthClientId) => {
  const [oauthClient, setOAuthClient] = useState(defaultValues);
  const [error, setError] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  const getOAuthClient = async (id) => {
    setIsLoading(true);
    await fetchOAuthClient(id)
      .then((o) => setOAuthClient(o))
      .catch((e) => setError(e))
      .finally(() => setIsLoading(false));
  };

  const submitUpdate = async (id, params, onSuccess) => {
    setIsLoading(true);
    await updateOAuthClient(id, params)
      .then((o) => {
        setOAuthClient(o);
        onSuccess();
      })
      .catch((e) => setError(e))
      .finally(() => setIsLoading(false));
  };

  const submitCreate = async (params, onSuccess) => {
    setIsLoading(true);
    await createOAuthClient(params)
      .then((o) => {
        setOAuthClient(o);
        onSuccess();
      })
      .catch((e) => setError(e))
      .finally(() => setIsLoading(false));
  };

  useEffect(() => {
    if (typeof oauthClientId == 'string') {
      if (oauthClientId != 'new') {
        getOAuthClient(oauthClientId);
      }
    }
  }, [oauthClientId]);

  return { oauthClient, submitUpdate, submitCreate, error, isLoading };
};

export default useOAuthClient;
